import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrthoview = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 24 24",
	xmlns: "http://www.w3.org/2000/svg",
	xmlnsXlink: "http://www.w3.org/1999/xlink",
	xmlSpace: "preserve",
	"xmlns:serif": "http://www.serif.com/",
	style: {
		fillRule: "evenodd",
		clipRule: "evenodd",
		strokeMiterlimit: 10
	},
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M17.759,4.63c-0.15,0.098 -7.083,6.551 0.126,14.27",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.365,22.394c0,0 -4.695,-5.133 -17.327,-10.54",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M20.533,1.538c0,0 -4.765,5.073 -17.471,10.317",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17.76,4.362c0,0 5.319,6.453 0,15.171",
			style: {
				fill: "none",
				fillRule: "nonzero",
				stroke: "currentColor",
				strokeWidth: "1.5px"
			}
		})
	] })
});
export default SvgOrthoview;
